__turbopack_context__.v({
  "container": "InfoCorner-module__EJe16W__container",
  "githubIcon": "InfoCorner-module__EJe16W__githubIcon",
  "infoIcon": "InfoCorner-module__EJe16W__infoIcon",
  "items": "InfoCorner-module__EJe16W__items",
  "linkHidden": "InfoCorner-module__EJe16W__linkHidden",
  "nav": "InfoCorner-module__EJe16W__nav",
  "toggleButton": "InfoCorner-module__EJe16W__toggleButton",
  "twitterIcon": "InfoCorner-module__EJe16W__twitterIcon",
});
